module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تجلَّت صورة الإنسانية في هذا الكتاب على شكل امرأة تنبذ العنف، وتبادله في الخير والمحبة، وكانت المرأة هي أكثر مَن دفع الثمن في رحَى هذه الحرب الطاحنة، فهي ثكلى بابنها أو زوجها أو أخيها، فإلى كلِّ مَن فجعَت في هذه الحرب أهدي لها هذا الكتاب.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 66
// module chunks = 0